import React, { memo, useReducer } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { Form } from '@redlink/components/organisms';
import { Space, withPopUp } from '@redlink/components/atoms';
import {
  FormSection,
  TextInput,
  DropDown,
  RadioButton,
} from '@redlink/components/molecules';
import { DataEntryModalTemplate } from '@redlink/components/templates';
import { useLocale } from '@redlink/assets/locale';
import { useMutation, newUserPageQuery } from '@redlink/services';
import { useValues } from '@redlink/assets/values';
import { initialState, reducer, types } from './store';
import { freshCache } from './cache';

const languages = [
  { id: 'fa', value: 'فارسی' },
  { id: 'en', value: 'English' },
];

export const NewPagePage = withPopUp(
  memo(({ onDismiss }) => {
    const { styles, colors } = useStyle();
    const { dictionary } = useLocale();
    const { constants } = useValues();

    const [{ pageName, language }, dispatch] = useReducer(
      reducer,
      initialState({ language: languages[0] })
    );

    const [submitPage, { loading: submitPageIsLoading }] = useMutation(
      newUserPageQuery,
      {
        done: () => onDismiss(),
        update: freshCache,
      }
    );

    return (
      <DataEntryModalTemplate>
        <Form
          isBusy={submitPageIsLoading}
          actions={[
            {
              title: dictionary.cancel,
              variant: 'secondary',
              onPress: onDismiss,
            },
            {
              title: dictionary.add,
              variant: 'primary',
              onPress: () =>
                submitPage({
                  pageName,
                  language: language.id,
                }),
            },
          ]}
        >
          {(containerLayout) => (
            <FormSection title={dictionary.addNewPage}>
              <TextInput
                require
                description={dictionary.newPageNameDescription}
                en
                title={dictionary.newPageName}
                prefix={`${constants.pageLinkPrefix}`}
                value={pageName}
                onChangeText={(value) =>
                  dispatch({
                    type: types.SET_PAGE_NAME,
                    payload: value.replace(' ', ''),
                  })
                }
              />
              <Space />
              <DropDown
                {...{ containerLayout }}
                title={dictionary.pageLanguage}
                text={language.value}
                data={languages}
                value={language}
                renderItem={({ value }) => {
                  const isSelected = language.value === value;
                  return (
                    <RadioButton
                      style={styles.itemText}
                      selected={isSelected}
                      title={value}
                      disabled
                    />
                  );
                }}
                onChange={(item) =>
                  dispatch({ type: types.SET_LANGUAGE, payload: item })
                }
              />
            </FormSection>
          )}
        </Form>
      </DataEntryModalTemplate>
    );
  })
);

const useStyle = createUseStyle(({ colors, size }) => ({
  rateContainer: {
    alignItems: 'center',
  },
  itemText: {
    paddingVertical: 10,
  },
}));
